import angelFundService from "@/api/angelFundService"
import dictionaryService from "@/api/dictionaryService"

const dictionary: any = {
    // 轮次
    protocalRoundList: [
        {name: '种子轮', value: 1},
        {name: '天使轮', value: 2},
        {name: 'Pre-A轮', value: 3},
        {name: 'A轮', value: 4},
        {name: 'A+轮', value: 5},
        {name: 'B轮', value: 6},
        {name: 'B+轮', value: 7},
        {name: 'C轮', value: 8},
        {name: 'C+轮', value: 9},
        {name: 'D轮', value: 10},
        {name: 'E轮', value: 11},
        {name: 'F轮', value: 12},
        {name: '并购', value: 13},
        {name: '新三板', value: 14},
        {name: '战略投资', value: 15},
        {name: 'Pre-IPO', value: 16},
        {name: 'IPO', value: 17},
    ],

    //  客户来源
    customerSource: [
        // { name: '资产', value: '1' },
        // { name: '工程', value: '2' },
        {name: '投资', value: '3'},
        // { name: '其他', value: '4' },
    ],
    // 客户分类
    customeType: [
        {name: '公司', value: '1'},
        {name: '自然人', value: '2'},
    ],
    // 是否外部企业
    outerDepart: [
        {name: '是', value: '1'},
        {name: '否', value: '2'},
    ],
    // 选聘类型
    hiringTypeList: [
        {name: '法律尽职调查', value: 1},
        {name: '财务尽职调查', value: 2},
        {name: '权益评估', value: 3},
    ],
    // 是否
    isOrNot: [
        {name: '是', value: '1'},
        {name: '否', value: '2'},
    ],

    areaUnit: [
        {name: '亩', value: '亩'},
        {name: '㎡', value: '㎡'},
    ],

    // 项目标签
    projectTag: [],

    dictNameConfig: {

    },
}

const dictGetters: any = {}

const dictMutations: any = {
    setDictNameConfig: (state: any) => {
        state.dictNameConfig = {
            PROJECT_TAG: 'investment_project_tag',
            WORD_BOOK_TAG: 'word_book_tag',
            WORD_BOOK_TYPE: 'word_book_type',
            WORD_PART: 'word_part',
            INDUSTRY_LIST: 'industry',
            PROJECT_INVESTMENT_TYPE: 'investment_project_investment_type',
            PROTOCAL_ROUNDS: 'investment_rounds',
            STAGE_STATUS: 'project_stage_status',
            FILE_TYPE: 'document_file_type',
            SOURCE_TYPE: 'project_source',
            IS_ELITE_PLAN: 'project_langing_is_nantaihu_elite_plan',
            ELITE_PLAN_LEVEL: 'nantaihu_elite_plan_level',
            DISTRICT_DEPARTMENT: 'district_department',
            DUI_DILIGENCE_TYPE: 'hiring_type',
            AGREEMENT_PART_TYPE: 'investment_project_agreement_part_type',
            AGREEMENT_TYPE: 'investment_project_agreement_type',
            IC_CHANGE_STATUS: 'ic_change_status',
            PROJECT_INVESTMENT_WAY: 'project_investment_way',
            INVESTMENT_ROUNDS: 'investment_rounds',
            RUNNING_SITUATION: 'angel_fund_org_type_running_situation',
            ORG_TYPE: 'investment_org_type',
            ORG_STATUS: 'angel_fund_status',
        };
    },
}

const dictActions: any = {
    async getDictionary({state, commit, dispatch}: any, {name, refresh}: any) {
        let dictName = state.dictNameConfig[name];
        if (!state[dictName] || !state[dictName].length || refresh) {
            state[dictName] = [];
            let result: any = await dictionaryService.getDictionaryItemListByDictCode(dictName);
            if (result.status == 200) {
                let list = result.result || [];
                state[dictName] = [];
                list.forEach((item: any) => {
                    state[dictName].push({name: item.itemName, value: item.itemValue},)
                })
            }
        }
        return state[dictName]
    },
    async getAngelFundOrg({state, commit, dispatch}: any, {name, refresh}: any) {
        let dictName = name;
        if (!state[dictName] || !state[dictName].length || refresh) {
            state[dictName] = [];
            let result: any = await angelFundService.getAngelFundOrgOptionDtoListByType(1);
            console.log('getAngelFundOrgOptionDtoListByType 1', result.result);
            if (result.status == 200) {
                let list = result.result || [];
                state[dictName] = [];
                list.forEach((item: any) => {
                    state[dictName].push({name: item.name, value: item.id},)
                })
            }
        }
        return state[dictName]
    },
    async getOtherFundOrg({state, commit, dispatch}: any, {name, refresh}: any) {
        let dictName = name;
        if (!state[dictName] || !state[dictName].length || refresh) {
            state[dictName] = [];
            let result: any = await angelFundService.getAngelFundOrgOptionDtoListByType(2);
            console.log('getAngelFundOrgOptionDtoListByType 2', result.result);
            if (result.status == 200) {
                let list = result.result || [];
                state[dictName] = [];
                list.forEach((item: any) => {
                    state[dictName].push({name: item.name, value: item.id},)
                })
            }
        }
        return state[dictName]
    },
    async getAllFunOrg({state, commit, dispatch}: any, {name, refresh}: any) {
        let dictName = name;
        if (!state[dictName] || !state[dictName].length || refresh) {
            state[dictName] = [];
            let result: any = await angelFundService.getAngelFundOrgOptionDtoList();
            console.log('getAngelFundOrgOptionDtoList', result.result);
            if (result.status == 200) {
                let list = result.result || [];
                state[dictName] = [];
                list.forEach((item: any) => {
                    state[dictName].push({name: item.name, value: item.id},)
                })
            }
        }
        return state[dictName]
    },
}

export {
    dictionary,
    dictGetters,
    dictMutations,
    dictActions,
};
